import { Controller } from "@hotwired/stimulus"

// Copies the current page URL (including the query string) to the clipboard
// so the user can paste it into chat/email. Used on the publishing queue so
// reviewers can share an exact filtered view.
//
// Falls back to a hidden <textarea> + document.execCommand("copy") on
// insecure contexts (plain HTTP) where navigator.clipboard isn't available.
export default class extends Controller {
  static targets = ["label"]
  static values = {
    copiedText: { type: String, default: "Copiado!" },
    resetMs: { type: Number, default: 2000 }
  }

  async copy(event) {
    event.preventDefault()
    const url = window.location.href

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url)
      } else {
        const ta = document.createElement("textarea")
        ta.value = url
        ta.style.position = "fixed"
        ta.style.left = "-9999px"
        document.body.appendChild(ta)
        ta.select()
        document.execCommand("copy")
        document.body.removeChild(ta)
      }
      this.showCopiedState()
    } catch (_e) {
      // Last-resort fallback: prompt the user with the URL so they can
      // copy it manually.
      window.prompt("Copie o link abaixo:", url)
    }
  }

  showCopiedState() {
    if (!this.hasLabelTarget) return
    const original = this.labelTarget.textContent
    this.labelTarget.textContent = this.copiedTextValue
    this.element.classList.add("btn-success")
    this.element.classList.remove("btn-outline")
    setTimeout(() => {
      this.labelTarget.textContent = original
      this.element.classList.remove("btn-success")
      this.element.classList.add("btn-outline")
    }, this.resetMsValue)
  }
}
